import { Reducer } from "@ctra/utils";

import { HerdGroupList } from "./typings";
import { types as farmTypes } from "../farms";
import { cleanup } from "../../utils/reducer";
import { NormalizedFarmList } from "../farms/schemas";

export const initialState: HerdGroupList = {};

/**
 * Herd group reducer
 * @param state
 * @param action
 */
const reducer: Reducer<HerdGroupList> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case farmTypes.FETCH_FARM_LIST.fulfilled: {
      const {
        entities: { herdGroup }
      } = payload as NormalizedFarmList;

      return {
        ...state,
        ...herdGroup
      };
    }
  }

  return state;
};

export default cleanup<HerdGroupList>(initialState)(reducer);
